import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type { SiteSection } from "./TeamDashboard";

// Разделы сайта для «Что открывают» — как в боковом меню.
export const SECTION_LABELS: Record<SiteSection, MessageDescriptor> = {
  home: msg`Home`,
  analysis: msg`Match analysis`,
  drills: msg`Training`,
  style: msg`Play style`,
  friends: msg`Friends`,
  profile: msg`Profile`,
  builds: msg`Builds`,
};
